import { Component, OnInit } from '@angular/core';
import { WompiRelayService } from '../../../services/wompi-relay.service';
import { LoadingService } from '../../../services/loading.service';
import { ToastService } from '../../../services/toast.service';
import { Router } from '@angular/router';
import { AuditInfo } from '../../../interfaces/audit.interfaces';

interface RelayUrl {
  id: number;
  name: string;
  targetUrl: string;
  isActive: boolean;
  description?: string;
  headers: any[];
  activeHeadersCount: number;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
}

@Component({
  selector: 'app-wompi-relay-list',
  templateUrl: './wompi-relay-list.component.html',
  styleUrls: ['./wompi-relay-list.component.scss']
})
export class WompiRelayListComponent implements OnInit {
  relayUrls: RelayUrl[] = [];
  filteredRelayUrls: RelayUrl[] = [];
  searchTerm: string = '';
  showDeleteConfirm: boolean = false;
  urlToDelete: RelayUrl | null = null;

  constructor(
    private wompiRelayService: WompiRelayService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadRelayUrls();
  }

  private loadRelayUrls(): void {
    this.loadingService.show();
    this.wompiRelayService.getAll().subscribe({
      next: (response) => {
        // Manejar estructura paginada: data puede ser array directo o {data: [...], totalCount: ...}
        const data = response?.data;
        this.relayUrls = Array.isArray(data) ? data : (data?.data || []);
        this.filteredRelayUrls = [...this.relayUrls];
        this.loadingService.hide();
      },
      error: (err) => {
        console.error(err);
        this.toastService.showToast('error', 'Error al cargar las URLs de relay');
        this.loadingService.hide();
      }
    });
  }

  applyFilters(): void {
    const search = this.searchTerm.toLowerCase();
    this.filteredRelayUrls = this.relayUrls.filter(url =>
      url.name.toLowerCase().includes(search) ||
      url.targetUrl.toLowerCase().includes(search) ||
      (url.description && url.description.toLowerCase().includes(search))
    );
  }

  toggleActivation(url: RelayUrl): void {
    this.loadingService.show();
    this.wompiRelayService.toggleActivation(url.id).subscribe({
      next: () => {
        const action = url.isActive ? 'desactivada' : 'activada';
        this.toastService.showToast('success', `URL ${action} exitosamente`);
        this.loadRelayUrls();
      },
      error: (err) => {
        console.error(err);
        this.toastService.showToast('error', 'Error al cambiar el estado de la URL');
        this.loadingService.hide();
      }
    });
  }

  viewLogs(url: RelayUrl): void {
    this.router.navigate(['/dashboard/config/wompi-relay', url.id, 'logs']);
  }

  editUrl(url: RelayUrl): void {
    this.router.navigate(['/dashboard/config/wompi-relay/edit', url.id]);
  }

  confirmDelete(url: RelayUrl): void {
    this.urlToDelete = url;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.urlToDelete = null;
    this.showDeleteConfirm = false;
  }

  deleteUrl(): void {
    if (!this.urlToDelete) return;

    this.loadingService.show();
    this.wompiRelayService.delete(this.urlToDelete.id).subscribe({
      next: () => {
        this.toastService.showToast('success', 'URL eliminada exitosamente');
        this.showDeleteConfirm = false;
        this.urlToDelete = null;
        this.loadRelayUrls();
      },
      error: (err) => {
        console.error(err);
        this.toastService.showToast('error', 'Error al eliminar la URL');
        this.loadingService.hide();
        this.showDeleteConfirm = false;
        this.urlToDelete = null;
      }
    });
  }

  getAuditData(url: RelayUrl): AuditInfo {
    return {
      createdBy: url.createdBy,
      createdAt: url.createdAt,
      updatedBy: url.updatedBy,
      updatedAt: url.updatedAt,
      deletedBy: undefined,
      deletedAt: undefined,
      isDeleted: false
    };
  }
}

